module.exports = __webpack_public_path__ + "img/tu_05.78733a38.png";